import React, { useImperativeHandle, forwardRef, useRef, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import uuid from 'react-uuid';
import { Modal } from 'bootstrap';
import HttpAPICall from '../../../../services/HttpAPICall';
import { INVENTORY_API_BASE_URL_2 } from '../../../../services/TapApiUrls';
import Loader from '../../../../components/ui/Loader/Loader';
import DateService from '../../../../services/DateService';
import TapIcon from '../../../../services/TapIcon';
import ItemViewInList from '../../../inventory/includes/ItemViewInList';
import ItemDetailsModal from '../../../items/itemDetails/ItemDetailsModal';
import CurrencyFormatter from '../../../../services/CurrencyFormatter';
import NumberFormatter from '../../../../services/NumberFormater';


const SalesInvoiceDetail = forwardRef((props, ref) => {


    let initVoucherData                     =   {
        transaction_id                          :   '',
        loading                                 :   false,
        data                                    :   null,
    };

    let voucherDetailUrl                    =   INVENTORY_API_BASE_URL_2 + "/sales_invoice/detail";

    
    const access_token                      =   useSelector(state => state.auth.access_token);
    const [voucherData, setVoucherData]     =   useState({...initVoucherData});
    const itemDetailsRef                    =   useRef(null);
    

    

    useEffect(() => {
        if (props.voucher) {
            setVoucherData(pd => ({...pd, loading : false, transaction_id : props.voucher.transaction_id  , data: props.voucher}));
        } else if (props.transaction_id) {
            setVoucherData(pd => ({...pd, loading : false, transaction_id: props.transaction_id}));
            
            initVoucherDetail(props.transaction_id);
        }
    }, []);

    const initVoucherDetail             =   (transaction_id)  =>  {
        setVoucherData(pd => ({...pd, loading : true }));
        let params                      =   {transaction_id : transaction_id };
        HttpAPICall.withAthorization('GET', voucherDetailUrl + '/' + transaction_id, access_token, params, {}, (response) => {
            setVoucherData(pd => ({...pd, data : response.data, transaction_id : transaction_id }));
        }).then(() => {
            setVoucherData(pd => ({...pd, loading : false}));
        });
    }

    const viewItemDetailModal                   =   (item)  =>  {
        if(itemDetailsRef.current) {
            itemDetailsRef.current.modalInit(item);
        }
    }

    const formatAddress = (address) => {
        if (!address) {
            return '-';
        }

        return <>
            {[address.address1, address.address2, address.landmark, address.city, address.district_name, address.state_name, address.country_name]
                .filter(Boolean)
                .join(', ')}
            {address.pincode ? ` - ${address.pincode}` : ''}
            <div>GSTIN: {address.gstin || '-'}</div>
        </>;
    };

    const invoiceForData = (invoice) => {
        if (!invoice?.invoice_for) {
            return { type: '-', name: '-' };
        }

        if (invoice.invoice_for === 'asset') {
            return {
                type: 'Asset',
                name: `${invoice.asset?.name || ''}${invoice.asset?.asset_code ? ` (${invoice.asset.asset_code})` : ''}`.trim() || '-'
            };
        }
        if (invoice.invoice_for === 'workstation') {
            return { type: 'Workstation', name: invoice.workstation?.workstation_name || invoice.workstation?.name || '-' };
        }
        if (invoice.invoice_for === 'employee') {
            return { type: 'Employee', name: invoice.employee?.display_full_name || invoice.employee?.full_name || invoice.employee?.name || '-' };
        }
        if (invoice.invoice_for === 'sub_assembly') {
            return { type: 'Sub Assembly', name: invoice.sub_assembly?.name || '-' };
        }
        return { type: invoice.invoice_for, name: '-' };
    };

    let item                        =   voucherData && voucherData.data ?  voucherData.data : null;
    const invoiceFor                =   invoiceForData(item);
    const groupedItems              =   item?.items?.reduce((groups, currentItem) => {
        const itemKey                 =   [
            currentItem.item_id,
            currentItem.sa_transaction_id,
            currentItem.so_transaction_id
        ].map(value => value ?? '').join('|');
        const batchKey                 =   [currentItem.batch_number, currentItem.expiry_date]
            .map(value => value ?? '').join('|');
        const existingItem            =   groups.get(itemKey);

        if (existingItem) {
            existingItem.qty            =   Number(existingItem.qty || 0) + Number(currentItem.qty || 0);
            existingItem.amount_with_discount_vc = Number(existingItem.amount_with_discount_vc ?? existingItem.amount_with_discount ?? existingItem.item_final_amount_vc ?? existingItem.item_final_amount ?? existingItem.item_with_discount ?? 0)
                + Number(currentItem.amount_with_discount_vc ?? currentItem.amount_with_discount ?? currentItem.item_final_amount_vc ?? currentItem.item_final_amount ?? currentItem.item_with_discount ?? 0);
            if (!existingItem.batchDetails.some(batch => batch.key === batchKey)) {
                existingItem.batchDetails.push({
                    key: batchKey,
                    batch_number: currentItem.batch_number,
                    expiry_date: currentItem.expiry_date
                });
            }
        } else {
            groups.set(itemKey, {
                ...currentItem,
                batchDetails: [{
                    key: batchKey,
                    batch_number: currentItem.batch_number,
                    expiry_date: currentItem.expiry_date
                }]
            });
        }

        return groups;
    }, new Map());
    const displayItems              =   Array.from(groupedItems?.values() || []);

    return <div>
        {voucherData.loading || !item ? <div className='text-center'><Loader /></div> : <>
            <table className="table table-bordered bg-white">
                <thead className="table-secondary">
                    <tr>
                        <th style={{ width: "33%" }}>ID</th>
                        <th style={{ width: "33%" }}>Date</th>
                        <th style={{ width: "33%" }}>Status</th>
                    </tr>    
                </thead>
                <tbody>
                    <tr>
                        <td>{item.transaction_id}</td>
                        <td>{DateService.dateFormat(item.transaction_date)}</td>
                        <td>{item.status_data ? item.status_data.name : "-"}</td>
                    </tr>
                </tbody>
            </table>
            <table className="table table-hover table-bordered  table-responsive bg-white mb-0">
                <tbody>
                    <tr>
                        <td style={{ width: "33%" }} >Warehouse</td>
                        <td colSpan={2}>
                            {item.warehouse ? <div><b>{item.warehouse.name} ({item.warehouse.code})</b><br />
                                {item.warehouse_address ? <div className='pt-1'>
                                    Address: {formatAddress(item.warehouse_address)}
                                </div> : <>GSTIN: {item.warehouse_gstin || '-'}</>}
                            </div> : '-'}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ width: "33%" }} >Customer</td>
                        <td colSpan={2}>{item.customer ? <div>{item.customer.name} ({item.customer.code})<br />
                            <div className='py-1'>
                                Project: {item.customer_project?.project_name || item.customerProject?.project_name || '-'}
                            </div>
                        </div> : '-'}</td>
                    </tr>
                    <tr>
                        <td style={{ width: "33%" }}></td>
                        <td style={{ width: "33%" }}>
                            <div><b>Bill To Address</b></div>
                            {formatAddress(item.customer_project?.address || item.customerProject?.address || item.customer_billing_address)}
                        </td>
                        <td style={{ width: "34%" }}>
                            <div><b>Ship To Address</b></div>
                            {formatAddress(item.customer_project?.address || item.customerProject?.address || item.customer_shipping_address)}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ width: "33%" }}>Sales Invoice For</td>
                        <td colSpan={2}>{invoiceFor.type}</td>
                    </tr>
                    {item.invoice_for ? <tr>
                        <td style={{ width: "33%" }}>{invoiceFor.type}</td>
                        <td colSpan={2}>{invoiceFor.name}</td>
                    </tr> : null}
                    <tr>
                        <td style={{ width: "33%" }}>Payment Terms</td>
                        <td className="text-capitalize">{item.payment_terms}</td>
                        <td>{item.net_days}</td>
                    </tr>
                    <tr>
                        <td style={{ width: "33%" }}>Deal</td>
                        <td colSpan={2} >{item.deal_data ? item.deal_data.header : "-"}</td>
                    </tr>
                    <tr>
                        <td style={{ width: "33%" }} >Voucher Number & Date</td>
                        <td style={{ width: "33%" }} >{item.voucher_number || '-'}</td>
                        <td className='text-center' style={{ width: "34%" }} >{item.voucher_date ? DateService.dateFormat(item.voucher_date) : <>-</>}</td>
                    </tr>
                    <tr>
                        <td style={{ width: "33%" }}>Tag Users</td>
                        <td colSpan={2}>
                            {item.users && item.users.length > 0
                                ? item.users.map((user, index) => <div key={user.id || user.enc_id || index}>{user.full_name || user.display_full_name || user.name || '-'}</div>)
                                : '-'}
                        </td>
                    </tr>
                    {item.additional_attribute_data && item.additional_attribute_data.length > 0
                        ? item.additional_attribute_data.map((attribute) => (
                            <tr key={attribute.id || attribute.key}>
                                <td className="text-capitalize">{attribute.name || '-'}</td>
                                <td colSpan={2}>{attribute.value_display || attribute.value || '-'}</td>
                            </tr>
                        ))
                        : null}
                </tbody>
            </table>
            <div className="tab_content_wrapper mt-3 my-1"><span className="content_heading">Item Detail</span></div>
            <div className="table-responsive">
                <table className="table table-hover table-bordered my-1">
                    <thead className="table-secondary">
                        <tr className="">
                            <th style={{ width: "5%" }}>S.No</th>
                            <th className="text-center" style={{ width: "30%" }}>Item Details</th>
                            <th className="text-center" style={{ width: "15%" }}>Batch Number <br />Expiry Date</th>
                            <th className="text-center" style={{ width: "15%" }}>Sales Order <br />Sales Allocation</th>
                            <th className="text-center" style={{ width: "7%" }}>Quantity</th>
                            <th className="text-center" style={{ width: "7%" }}>Unit Rate</th>
                            <th className="text-center" style={{ width: "7%" }}>Discount</th>
                            <th className="text-center" style={{ width: "7%" }}>GST</th>
                            <th className="text-center" style={{ width: "7%" }}>Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                    {displayItems.length > 0 ? displayItems.map((i, k) => {
                        return (<tr key={k}>
                            <td className='text-center'>{k + 1}</td>
                            <td>{i.item_profile && <div className='row'>
                                    <div className='col-sm-12'>
                                        <ItemViewInList item={i.item_profile} remark={i.remark} viewItemModal={() => viewItemDetailModal(i.item_profile)} />
                                    </div>
                                </div>}
                            </td>
                            <td>
                                {i.batchDetails.map((batch, batchIndex) => <div key={batch.key + batchIndex}>
                                    BN : <b> {batch.batch_number || ""} </b> <br />
                                    ED: <b> {DateService.dateFormat(batch.expiry_date) || ""} </b>
                                </div>)}
                            </td>
                            <td>
                                <div>SO : {i.so_transaction_id && i.so_transaction_id}</div>
                                <div>SA : {i.sa_transaction_id && i.sa_transaction_id}</div>
                            </td>
                            <td className='text-end'>
                                {i.qty }
                                {i.item_profile && i.item_profile.measuring_unit && <span className="text-helping input-group-text text-end pr0">{i.item_profile.measuring_unit.name}</span>}
                            </td>
                            <td>{i.rate}</td>
                            <td className='text-end'>{i.discount_rate > 0 ? <div>{i.discount_type == "Fixed" && 'INR'} {i.discount_rate} {i.discount_type == "Percentage" && "%"}</div> : '-'}</td>
                            <td className="text-end">{i.gst > 0 ? (i.gst + ' %') : '-'}</td>
                            <td className="text-end">{Number(i.amount_with_discount_vc ?? i.amount_with_discount ?? i.item_final_amount_vc ?? i.item_final_amount ?? i.item_with_discount ?? 0).toFixed(2)}</td>
                        </tr>)})
                        : <tr ><td className='text-center' colSpan={10}>No Record</td></tr>
                    }
                    </tbody>
                </table>
            </div>
            <div className="row align-items-center mt-3 mb-5">
                <div className="col-sm-6">
                    <label className="form-label">Notes</label><div>{item.notes || "-"}</div>
                </div>
                <div className="col-sm-6">
                    <table className="table table-borderless subtotal_bg_color">
                        <tbody>
                            <tr className="subtotal_bg_color">
                                <th style={{width:"50%"}}>Sub-Total ({item.currency || 'INR'})</th>
                                <td style={{width:"50%"}} className="text-end">
                                    <CurrencyFormatter
                                        currencyCode={item.currency || 'INR'}
                                        amount={Number(item.sub_total_amount_vc ?? item.items.reduce((total, row) => total + Number(row.amount_with_discount_vc ?? row.amount_with_discount ?? row.item_final_amount_vc ?? row.item_final_amount ?? row.item_with_discount ?? 0), 0)).toFixed(2)}
                                    />
                                </td>
                            </tr>
                            {item.tax_slabs && item.tax_slabs.length > 0 && (item.tax_slabs.map((ps, k) => {
                                return <tr><th>{ps.key}</th><td className="text-end">{ps.value}</td></tr>
                            }))}
                            <tr className='align-middle'>
                                <th>TCS ({item.tcs_type == "Fixed" && 'INR'} {item.tcs_rate} {item.tcs_type == "Percentage" && "%"} )</th>
                                <th className='text-end'>
                                    <NumberFormatter number={item.tcs_amount} precision={2} />
                                </th>
                            </tr>
                            <tr className="">
                                <th>Adjustment</th>
                                <td className='text-end'>{item.adjustment_amount}</td>
                            </tr>
                            <tr className="align-middle">
                                <th>Final Total ({item.currency || 'INR'})</th>
                                <td className='text-end'><NumberFormatter number={item.total_amount_vc ?? item.total_amount} precision={2} /></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="tab_content_wrapper content_heading">Terms & Condition</div>
            <table className="table table-hover table-bordered bg-white my-3">
                <thead className='table-secondary'>
                    <tr>
                        <th className='text-center' style={{ width: "10%" }}>S.No</th>
                        <th className='text-start' style={{ width: "25%" }}>Name</th>
                        <th className='text-start' style={{ width: "65%" }}>Description</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        item?.tnc && item.tnc.length > 0 ? item.tnc.map((tc, k) => {
                            return (<tr key={k}>
                                <td className='text-center'>{k + 1}</td>
                                <td>{tc.name}</td>
                                 <td dangerouslySetInnerHTML={{ __html: tc.text }} />
                            </tr>);
                        })
                            : <tr ><td className='text-center' colSpan={3}>No Record</td></tr>
                    }

                </tbody>
            </table>

        </>}
        <ItemDetailsModal ref={itemDetailsRef} />
    </div>

});

export default SalesInvoiceDetail;